import React from "react";

const CardDetailProject = ({ title = "", children, headerChildren, titleClass = "" }) => {
    return (
        <div className="rounded-[5px] flex flex-col my-0 mx-auto bg-white w-full h-full p-4">
            <div className="w-full flex flex-wrap gap-2 justify-between items-center mb-3 ">
                <h2 className={`text-[#282828]  font-bold leading-normal   ${titleClass} `}>{title}</h2>
                {headerChildren}
            </div>
            <div className="flex flex-row w-full h-full pt-3">{children}</div>
        </div>
    );
};

export default CardDetailProject;
